module.exports = __webpack_public_path__ + "static/img/indexBtn2.ef31a64.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/padImage/indexBtn2.jpg
// module id = p2fX
// module chunks = 1